import type { MessageTemplateState } from './message-template-selectors';
import { STARTING, SUCCESS } from '../action/util/action-name-creators';
import type { Action } from '../reducers/utils/state-manager';
import { updateResourceByParam } from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState = {
  hiringMessageTemplatesById: {},
  hiringMessageTemplatesStateById: {},
  hiringMessageTemplatesStateByJobId: {},
  employeeMessageTemplatesById: {},
  employeeMessageTemplatesStateById: {},
  employeeMessageTemplatesStateByOrgId: {},
};

export const messageTemplateReducer = (
  state: MessageTemplateState = InitialState,
  action: Action,
) => {
  switch (action.type) {
    case STARTING('LOAD_JOB_MESSAGE_TEMPLATES'): {
      const { jobId } = action.payload.args;
      return updateResourceByParam(state, 'hiringMessageTemplates', 'jobId', jobId, true);
    }
    case SUCCESS('LOAD_JOB_MESSAGE_TEMPLATES'): {
      const {
        args: { jobId },
        data,
      } = action.payload;
      // IF (07/27/20): The typing isn't quite right for message templates. We combine the actual
      // type with "create" version where templateId isn't defined. Those should be split out but
      // here you can always expect there to be a templateId.
      const hiringMessageTemplatesById = convertArrayToMap(data, (template: TextMessageTemplate) =>
        String(template.templateId),
      );
      return updateResourceByParam(
        state,
        'hiringMessageTemplates',
        'jobId',
        jobId,
        false,
        hiringMessageTemplatesById,
      );
    }
    case STARTING('LOAD_EMPLOYEE_MESSAGE_TEMPLATES'): {
      const { orgId } = action.payload.args;
      return updateResourceByParam(state, 'employeeMessageTemplates', 'orgId', orgId, true);
    }
    case SUCCESS('LOAD_EMPLOYEE_MESSAGE_TEMPLATES'): {
      const {
        args: { orgId },
        data,
      } = action.payload;
      const employeeMessageTemplatesById = convertArrayToMap(
        data,
        (template: EmployeeMessageTemplate) => template.employeeMessageTemplateId.toString(),
      );
      return updateResourceByParam(
        state,
        'employeeMessageTemplates',
        'orgId',
        orgId,
        false,
        employeeMessageTemplatesById,
      );
    }
    case STARTING('UPDATE_HIRING_MESSAGE_TEMPLATE'): {
      const { templateId } = action.payload.args;
      return updateResourceByParam(state, 'hiringMessageTemplates', 'id', templateId, true);
    }
    case SUCCESS('UPDATE_HIRING_MESSAGE_TEMPLATE'): {
      const {
        args: { templateId },
        data,
      } = action.payload;
      return updateResourceByParam(state, 'hiringMessageTemplates', 'id', templateId, false, {
        [templateId]: data,
      });
    }
    case STARTING('UPDATE_EMPLOYEE_MESSAGE_TEMPLATE'): {
      const { employeeMessageTemplateId } = action.payload.args;
      return updateResourceByParam(
        state,
        'employeeMessageTemplates',
        'id',
        employeeMessageTemplateId,
        true,
      );
    }
    case SUCCESS('UPDATE_EMPLOYEE_MESSAGE_TEMPLATE'): {
      const {
        args: { employeeMessageTemplateId },
        data,
      } = action.payload;
      return updateResourceByParam(
        state,
        'employeeMessageTemplates',
        'id',
        employeeMessageTemplateId,
        false,
        { [employeeMessageTemplateId]: data },
      );
    }
    case SUCCESS('ADD_HIRING_MESSAGE_TEMPLATE'): {
      const { data } = action.payload;
      return updateResourceByParam(state, 'hiringMessageTemplates', 'id', data.templateId, false, {
        [data.templateId]: data,
      });
    }
    case SUCCESS('ADD_EMPLOYEE_MESSAGE_TEMPLATE'): {
      const { data } = action.payload;
      return updateResourceByParam(
        state,
        'employeeMessageTemplates',
        'id',
        data.employeeMessageTemplateId,
        false,
        { [data.employeeMessageTemplateId]: data },
      );
    }
    default:
      return state;
  }
};
